import { useState } from "react";
import { useBalance } from "wagmi";
import { formatUnits } from "viem";

import {
    DEFAULT_DECIMALS,
    ERROR_BALANCE_WALLET,
} from "../utils/config";

import { _getNotETHValue, _notEmpty } from "../utils";

const useWalletBalance = ({
    chainId,
    userAccount,
    token = null
}) => {

    const [walletBalance, setWalletBalance] = useState();

    const { isLoading } = useBalance({
        chainId,
        address: userAccount,
        token: _getNotETHValue(token?.name, token?.address),
        enabled: _notEmpty(chainId),
        watch: true,
        onError: (error) => {
            console.error(
                ERROR_BALANCE_WALLET,
                error
            );
        },
        onSuccess: (data) => {
            const balance = data.value;

            const balanceFormatted = formatUnits(
                balance,
                token?.decimals ?? DEFAULT_DECIMALS
            );

            setWalletBalance({
                balance,
                balanceFormatted
            });
        }
    });

    return { walletBalance, isFetching: isLoading };
};

export default useWalletBalance;
